import type { VersionApi } from "@/Modules/Models/Api/Versions";

import TherapySideApiService from "@/Services/TherapyApi/utils/TherapyApi";

class VersionsAPIConnector {
  constructor(private readonly ApiService: TherapySideApiService = new TherapySideApiService()) {}

  getRequirements(): Promise<VersionApi> {
    return this.ApiService.get<void, VersionApi>({
      endpoint: "/v1.0/mobile_versions",
    });
  }
}

export default VersionsAPIConnector;
